import { render, staticRenderFns } from "./Plugin.vue?vue&type=template&id=5b8077b9"
import script from "./Plugin.vue?vue&type=script&lang=js"
export * from "./Plugin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports